import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { Feature, PagedFeatures } from 'stores/FeatureStore';
import { ActionIcon, DeleteIcon, EditIcon } from 'components/Icon';
import { DefaultCopyToClipboard } from 'components/CopyToClipboard';
import { SimpleInlineHelp } from 'components/InlineHelp';

interface Props
{
  features: PagedFeatures,
  editFeatureHandler: (feature: Feature) => Promise<void>,
  deleteFeatureHandler: (feature: Feature) => Promise<void>,
}
export const FeatureList: React.FC<Props> = observer(({features, editFeatureHandler, deleteFeatureHandler}: Props) =>
{
  const { uiStore } = useStore();

  return (
    <table>
      <thead>
        <tr>
          <th>{uiStore.labels.pages.features.table.tokenColumnName}<SimpleInlineHelp>{uiStore.labels.help.features.token.about}</SimpleInlineHelp></th>
          <th>{uiStore.labels.pages.features.table.nameColumnName}</th>
          <th>{uiStore.labels.pages.features.table.descriptionColumnName}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {
          features.data?.map(x =>
            <tr key={x.token}>
              <td>
                <Link title={uiStore.labels.pages.features.viewDetailsOfFeature.apply({featureName: x.name})}
                      to={{pathname: paths.buildFeatureViewPath(x.token || ''), state: { isCancelRequired: true }}}>
                  {x.token}
                </Link>
                <DefaultCopyToClipboard text={x.token} />
              </td>
              <td>{x.name}</td>
              <td>{x.description}</td>
              <td className="actions">
                <ActionIcon tip={uiStore.labels.pages.features.editFeature.apply({featureName: x.name})} action={async () => await editFeatureHandler(x)}><EditIcon /></ActionIcon>
                <ActionIcon tip={uiStore.labels.pages.features.deleteFeature.apply({featureName: x.name})} action={async () => await deleteFeatureHandler(x)}><DeleteIcon /></ActionIcon>
              </td>
            </tr>)
        }
      </tbody>
    </table>
  );
});